const config = {
    DEBUGMODE: true,
    PRODUCTION: true,
}

// we have this if but we can't use because
// we need the variable in build before upload on the server
// **(window.location.origin.includes('alwelhost.com')) ? true : false**
// config.frontpoint = config.PRODUCTION ? "https://alwelhost.com/" : "https://localhost:8080/";
config.frontpoint = config.PRODUCTION ? "https://newabc-app.com" : "https://192.168.0.80:8080/";
config.endpoint = config.PRODUCTION ? "https://newabc-app.com/api/" : "http://127.0.0.1/ace_app/api/";

export default config;
